import React from 'react';
import Icon from '../../../components/AppIcon';

const AnnouncementsPanel = ({ announcements }) => {
  const formatAnnouncementTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / 60000);

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-primary';
      default:
        return 'text-muted-foreground';
    }
  };

  if (announcements?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 md:p-8">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
            <Icon name="Megaphone" size={32} color="var(--color-muted-foreground)" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
            No Announcements
          </h3>
          <p className="text-sm md:text-base text-muted-foreground max-w-sm">
            Stay tuned for important updates and announcements from the event organizers
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-5 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Megaphone" size={20} color="var(--color-secondary)" />
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              Announcements
            </h3>
          </div>
          {announcements?.some(a => !a?.read) && (
            <span className="px-2.5 py-1 bg-accent/10 text-accent text-xs md:text-sm font-semibold rounded-full">
              {announcements?.filter(a => !a?.read)?.length} New
            </span>
          )}
        </div>
      </div>
      <div className="divide-y divide-border max-h-[400px] md:max-h-[500px] overflow-y-auto">
        {announcements?.map((announcement) => (
          <div 
            key={announcement?.id} 
            className={`p-4 md:p-5 hover:bg-muted transition-smooth ${!announcement?.read ? 'bg-primary/5' : ''}`}
          >
            <div className="flex gap-3 md:gap-4">
              <div className={`flex-shrink-0 ${getPriorityColor(announcement?.priority)}`}>
                <Icon name="AlertCircle" size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-2">
                    {announcement?.title}
                  </h4>
                  {!announcement?.read && (
                    <div className="flex-shrink-0 w-2 h-2 bg-accent rounded-full mt-1" />
                  )}
                </div>
                <p className="text-xs md:text-sm text-muted-foreground line-clamp-3 mb-2">
                  {announcement?.message}
                </p>
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="data-text">{formatAnnouncementTime(announcement?.timestamp)}</span>
                  {announcement?.priority === 'high' && (
                    <span className="px-2 py-0.5 bg-error/10 text-error rounded-full font-semibold">
                      Important
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementsPanel;